import { useNavigate } from "react-router-dom";
import blankcart from "../../../../assets/images/blank-cart.png";
import rightarrawwhite from "../../../../assets/icons/rightarrawwhite.png";

const CartEmpty = () => {
    const navigate = useNavigate();

    return (
        <div className="empty-cart">
            <img src={blankcart} alt="Empty cart" className="empty-cart-image" />
            <h3>Your cart is feeling a little empty</h3>
            <p>
                Discover our curated collection of premium rugs that transform any space.
            </p>

            <button
                className="empty-cart-btn"
                onClick={() => navigate("/")}
            >
                EXPLORE
                <img src={rightarrawwhite} alt="" height={25} width={25} />
            </button>
        </div>
    );
};

export default CartEmpty;